import { jsx as _jsx } from "react/jsx-runtime";
import { useAppConfig } from "@madmedical/config";
import { useTranslation } from "@madmedical/i18n";
import Button from "../atoms/Button";
const ConsultationButton = () => {
    const { onConsultationPress } = useAppConfig();
    const { t } = useTranslation();
    if (!onConsultationPress) {
        return null;
    }
    return (_jsx(Button, Object.assign({ onPress: onConsultationPress, variant: "outlined", leftIconName: "stethoscope", forceIcon: true }, { children: t("needConsult") })));
};
export default ConsultationButton;
